import React, { useState, useEffect } from "react";
import { Input, Text } from "@fragments";
import { CategoryRounded } from "@mui/icons-material";

import CATEGORIES from "../enums/categories";

export default function SelectCategories({ value, onChange }) {
    const [localCategories, setLocalCategories] = useState(value);

    useEffect(() => {
        onChange(localCategories);
    }, [localCategories]);

    const handleCategoryChange = (selected) => {
        setLocalCategories([...selected]);
    };

    return (
        <div className="mt-4 mb-1">
            <Text.h3
                value="Keywords"
                left={<CategoryRounded />}
                className="mb-1 mt-3"
            />
            <Text.h5 contrast={5}>Selecione até 3 palavras-chave para classificar seu conteúdo</Text.h5>
            <Input.SelectOptions
                className="mt-2"
                label="Categorias (máximo 3)"
                options={CATEGORIES}
                value={localCategories}
                onInput={handleCategoryChange}
                maxItems={3}
            />
        </div>
    );
}
